import type { Counts } from "../../shared/srs";

export function StatChips({ counts, streak }: { counts: Counts; streak: number }) {
  return (
    <div className="chips">
      <div className="chip-group">
        <div className="chip chip-new">
          <b>{counts.new}</b> new
        </div>
        <div className="chip chip-learning">
          <b>{counts.learning}</b> learning
        </div>
        <div className="chip chip-known">
          <b>{counts.known}</b> known
        </div>
      </div>
      {streak >= 2 && <div className="streak">Streak {streak}</div>}
    </div>
  );
}
